<template>
  <ul class="specs-with-sub-specs w-100">
    <li v-for="({ title, tooltipText, active, details }, index) in specs" :key="index">
      <div v-if="active" class="spec">
        <h6 class="spec-title font-weight-normal m-0">{{ title }}</h6>
        <div v-show="tooltipText" v-b-tooltip.hover :title="tooltipText">
          <i
            class="ph-bold ph-question"
            :style="{ fontSize: '20px', color: 'var(--primary-color)' }"
          ></i>
        </div>
      </div>
      <ul v-if="details.length">
        <li v-for="({ title: detailTitle, quantity }, detailIndex) in details" :key="detailIndex">
          <div class="sub-spec">
            <p class="sub-spec-title m-0">{{ detailTitle }}</p>
            <p class="sub-spec-ammount m-0">{{ quantity }}</p>
          </div>
        </li>
      </ul>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    specs: {
      type: Array,
      required: true
    }
  }
};
</script>
<style lang="scss" scoped>
ul {
  padding: 0;
}
.specs-with-sub-specs {
  list-style: none;
  padding: 0;
  display: grid;
  gap: 1em;
  color: var(--primary-color);
  > li {
    border-bottom: 0.5px solid var(--primary-color);
    display: grid;
    padding-bottom: 0.5em;
  }
  > li:last-child {
    border-bottom: none;
  }

  .spec {
    display: flex;
    justify-content: space-between;
    gap: 1rem;

    .spec-title {
      font-size: 0.8rem;
      line-height: 1em;
    }
  }
  .sub-spec {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 1rem;
    .sub-spec-title {
      font-size: 0.8em;
    }
    .sub-spec-ammount {
      font-weight: 800;
      font-size: 0.8em;
    }
  }
}
</style>
